import { API_PATH_INTERNAL } from '@/lib/constants'
import { getOrFail } from '@/lib/helpers/helperFunctions'
import { CommonData } from '@/types/responses/common-data'
import { AvailableServiceAreaCollectionItem } from '@/types/responses/companies'

class ServiceAreaService {
  private endpoint = `${API_PATH_INTERNAL}/service-areas`

  getServiceAreaByIri(
    iri: IRI,
    serviceAreas: CommonData['serviceAreas'],
  ): AvailableServiceAreaCollectionItem {
    const serviceArea = serviceAreas.find(
      (serviceArea) => serviceArea['@id'] === iri,
    )

    return getOrFail(serviceArea, `Service area with IRI ${iri} not found`)
  }

  getIri(id: number): IRI {
    return `${this.endpoint}/${id}`
  }
}

const serviceAreaService = new ServiceAreaService()

export default serviceAreaService
